import { useEffect, useRef } from "react";
import firebase from "../../services/firestore";
import catLogin from "url:../../assets/images/login.png";
import { UIStore } from "../../store/UIStore";
import styled from "@emotion/styled";
import styles from "./LoginScreen.module.scss";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

const StyleWrapper = styled.div`
  #firebaseui-auth-container {
    button {
      color: var(--colors-primary);
    }

    button[type="submit"] {
      background-color: var(--colors-primary);
      color: white;
    }

    .mdl-shadow--2dp {
      box-shadow: none;
    }

    .firebaseui-textfield.mdl-textfield .firebaseui-label::after {
      background-color: var(--colors-primary);
    }
  }
`;

const LoginScreen = () => {
  const userInfo = UIStore((state) => state.userInfo);
  const uiRef = useRef(null);

  useEffect(() => {
    if (!uiRef.current) {
      // Initialize FirebaseUI
      const ui =
        firebaseui.auth.AuthUI.getInstance() ||
        new firebaseui.auth.AuthUI(firebase.auth());

      const uiConfig = {
        signInFlow: "popup",
        signInOptions: [
          firebase.auth.EmailAuthProvider.PROVIDER_ID,
          {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            customParameters: {
              hd: "playgroundxyz.com", // force company accounts
            },
          },
        ],
        callbacks: {
          signInSuccessWithAuthResult: () => false, // prevent redirect
        },
      };

      ui.start("#firebaseui-auth-container", uiConfig);
      uiRef.current = ui;
    }
  }, []);

  if (userInfo.loggedIn === false) {
    return (
      <div className={styles.loginScreen}>
        <div className={styles.loginWrapper}>
          <img src={catLogin} alt="login" />
          <h1>Please Login</h1>
          <p>
            Login with your GumGum Google Account to access the Creative
            Analytics Tracker.
          </p>
          <StyleWrapper>
            <div id="firebaseui-auth-container" />
          </StyleWrapper>
        </div>
      </div>
    );
  }

  return null;
};

export default LoginScreen;
